import { trustNumbers } from "@/mocks/siteContent";

export default function TrustNumbers() {
  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-2">
              10,000+ Finds{' '}
              <span className="text-primary-500">Verified by Community</span>
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              Real data from real shoppers — updated every week
            </p>
          </div>
          <span className="inline-flex items-center gap-2 bg-secondary-100 text-secondary-800 text-xs font-semibold px-4 py-2 rounded-full whitespace-nowrap w-fit">
            <span className="w-2 h-2 bg-secondary-500 rounded-full animate-pulse"></span>
            Updated Weekly
          </span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {trustNumbers.map((item) => (
            <div
              key={item.label}
              className="bg-background-50 rounded-lg p-6 md:p-8 text-center hover:bg-background-50 transition-colors border border-background-200/70"
            >
              <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-2">
                {item.value}
              </p>
              <p className="text-sm font-semibold text-foreground-700 mb-1">
                {item.label}
              </p>
              <p className="text-xs text-foreground-400">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}